import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import './AccountHeads.css'; // Reusing similar styling
import './ProjectTypes.css';
import { toast } from '../components/Toast';

function ProjectTypes() {
  const [projectTypes, setProjectTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    active: true
  });

  useEffect(() => {
    fetchProjectTypes();
  }, []);

  const fetchProjectTypes = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/project-types');
      setProjectTypes(response.data.data || []);
    } catch (error) {
      console.error('Error fetching project types:', error);
      toast.error('Failed to load project types');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (editingId) {
        await axios.put(`/project-types/${editingId}`, formData);
        toast.success('Project type updated successfully');
      } else {
        await axios.post('/project-types', formData);
        toast.success('Project type created successfully');
      }
      
      resetForm();
      fetchProjectTypes();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to save project type');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (type) => {
    setFormData({
      name: type.name,
      description: type.description || '',
      active: type.active
    });
    setEditingId(type.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this project type?')) return;
    
    setLoading(true);
    try {
      await axios.delete(`/project-types/${id}`);
      toast.success('Project type deleted successfully');
      fetchProjectTypes();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to delete project type');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({ name: '', description: '', active: true });
    setEditingId(null);
    setShowForm(false);
  };

  return (
    <div className="account-heads-page">
      <div className="page-header">
        <h1>Project Types</h1>
        <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Add Project Type'}
        </button>
      </div>



      {showForm && (
        <div className="form-card">
          <h2>{editingId ? 'Edit Project Type' : 'New Project Type'}</h2>
          <form onSubmit={handleSubmit} className="account-form">
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g., Residential, Commercial"
                required
              />
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Brief description of this project type"
                rows="3"
              />
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                />
                <span>Active</span>
              </label>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Saving...' : editingId ? 'Update' : 'Create'}
              </button>
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="accounts-list">
        {loading && !showForm ? (
          <div className="loading">Loading...</div>
        ) : projectTypes.length === 0 ? (
          <div className="no-data">No project types found. Create one to get started.</div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {projectTypes.map(type => (
                <tr key={type.id}>
                  <td data-label="Name"><strong>{type.name}</strong></td>
                  <td data-label="Description">{type.description || '—'}</td>
                  <td data-label="Status">
                    <span className={`status-badge ${type.active ? 'status-active' : 'status-inactive'}`}>
                      {type.active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td data-label="Actions" className="actions-cell">
                    <div className="action-buttons">
                      <button className="btn btn-sm btn-secondary" onClick={() => handleEdit(type)}>
                        Edit
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(type.id)}>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ProjectTypes;
